import { getTheme, IStackItemStyles, Stack } from '@fluentui/react';
import React from 'react';

export const BaseTab: React.FC = props => {
  const { palette } = getTheme();

  const baseCardStyle: IStackItemStyles = {
    root: {
      backgroundColor: palette.white,
      maxWidth: 880
    }
  };
  return (
    <div className="ms-Grid m-3">
      <div className="ms-Grid-row">
        <div className="ms-Grid ml-5">
          <Stack
            tokens={{ childrenGap: 1 }}
            className="ms-grid px-5 py-4 ms-depth-4 rounded my-3"
            styles={baseCardStyle}
          >
            {props.children}
          </Stack>
        </div>
      </div>
    </div>
  );
};
